import React from 'react';
import { withEssentialsContext } from '../../contexts/essentials-context';
import type { ExternalComponentProps } from '../types';
import type { AppBenefitsBadgeProps as AppBenefitsBadgePropsInternal } from '../../components/badges/app-benefits-badge';
import { AppBenefitsBadge as AppBenefitsBadgeInternal } from '../../components/badges/app-benefits-badge';

export interface AppBenefitsBadgeProps
  extends ExternalComponentProps,
    AppBenefitsBadgePropsInternal {}

export function AppBenefitsBadgeComponent(props: AppBenefitsBadgeProps) {
  return <AppBenefitsBadgeInternal {...props} />;
}

export const AppBenefitsBadge = withEssentialsContext(
  AppBenefitsBadgeComponent,
);
